import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

// Pricing versions for mrpa were created before we agreed on a unified standard.
// This is why we use an empty prefix, for retro-compatibility.
type MrpaPricingVersionFormat = PricingVersionFormat<'mrpa', ''>

export const mrpaPricingVersions = [
  ['mrpa-1.0.0-2025-11-01', { label: 'Version 1' }],
  ['mrpa-1.0.1-2027-01-01', { label: 'Version 1.0.1 - Terrorism tax €8.50' }],
] as const satisfies PricingVersionTuple<MrpaPricingVersionFormat>[]

export type MrpaPricingVersion = (typeof mrpaPricingVersions)[number][0]
